import React from "react";
import { NavLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { removeAuth } from "../actions";
import { ROLE_LABELS, PERMISSION, ROLE } from "../utils/constants";
import { hasPermission, hasAnyPermission } from "../utils/permissions";
import { clearSession } from "../utils/api";


const Sidebar = ({ name, role, permissions, removeAuth, history, collapsed, setCollapsed }) => {

  const handleLogout = () => {
    clearSession();
    localStorage.removeItem("teleLeadFilters");
    removeAuth();
    history.push("/login");
  };

  const has = (code) => hasPermission(permissions, code);
  const hasAny = (codes) => hasAnyPermission(permissions, codes);

  const toggleSidebar = () => setCollapsed((prev) => !prev);

  return (
    <div
      className={`sidebar${collapsed ? " collapsed" : ""}`}
      style={{
        width: collapsed ? 60 : 220,
        transition: "width 0.2s",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="brand" style={{ display: "flex", alignItems: "center", justifyContent: collapsed ? "center" : "flex-start", padding: "10px 15px" }}>
        <i className="fas fa-phone-alt"></i>
        {!collapsed && <span style={{ marginLeft: 8 }}>Tele Leads</span>}
        <button
          onClick={toggleSidebar}
          style={{
            marginLeft: "auto",
            background: "none",
            border: "none",
            color: "#8aa4af",
            fontSize: 16,
            cursor: "pointer",
            outline: "none",
            padding: 0,
          }}
          title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <i className={`fas fa-angle-${collapsed ? "right" : "left"}`}></i>
        </button>
      </div>
      <ul style={{ paddingLeft: collapsed ? 0 : 20, flex: 1, overflowY: "auto", overflowX: "hidden", marginBottom: 0 }}>
        {/* <li>
          <NavLink to="/dashboard" activeClassName="active">
            <i className="fas fa-tachometer-alt"></i> {!collapsed && "Dashboard"}
          </NavLink>
        </li> */}
     {has(PERMISSION.LEADS_ACCESS) && (
         <li>
          <NavLink to="/leads" exact activeClassName="active">
            <i className="fas fa-list"></i> {!collapsed && "Leads"}
          </NavLink>
        </li>
     )}
        {/* <li>
          <NavLink to="/leads/add" activeClassName="active">
            <i className="fas fa-plus-circle"></i> {!collapsed && "Add Lead"}
          </NavLink>
        </li> */}
        {has(PERMISSION.TEAM_DASHBOARD_ACCESS) && (
          <li style={{ borderTop: "1px solid #1a2226", marginTop: 15, paddingTop: 5 }}>
            <NavLink to="/team-dashboard" activeClassName="active">
              <i className="fas fa-chart-line"></i> {!collapsed && "Team Dashboard"}
            </NavLink>
          </li>
        )}
        {has(PERMISSION.FLAGGED_LEADS_ACCESS) && (
          <li>
            <NavLink to="/executive/report/flagged" activeClassName="active">
              <i className="fas fa-flag text-danger"></i> {!collapsed && "Flagged Leads"}
            </NavLink>
          </li>
        )}
        {(has(PERMISSION.TEAMS_ACCESS) || has(PERMISSION.INCENTIVES_ACCESS)) && (
          <>
            {has(PERMISSION.TEAMS_ACCESS) && (
              <li>
                <NavLink to="/teams" activeClassName="active">
                  <i className="fas fa-users"></i> {!collapsed && "Manage Teams"}
                </NavLink>
              </li>
            )}
            {has(PERMISSION.INCENTIVES_ACCESS) && (
              <li>
                <NavLink to="/incentives" activeClassName="active">
                  <i className="fas fa-gift"></i> {!collapsed && "Incentive Plans"}
                </NavLink>
              </li>
            )}
          </>
        )}
        {hasAny([PERMISSION.ADMIN_SUMMARY_ACCESS, PERMISSION.REPORT_POSTED_ACCESS]) && (
          <>
            {has(PERMISSION.ADMIN_SUMMARY_ACCESS) && (
              <li style={{ borderTop: "1px solid #1a2226", marginTop: 15, paddingTop: 5 }}>
                <NavLink to="/admin/summary" activeClassName="active">
                  <i className="fas fa-chart-pie"></i> {!collapsed && "Summary"}
                </NavLink>
              </li>
            )}
            {has(PERMISSION.REPORT_POSTED_ACCESS) && (
              <li style={!has(PERMISSION.ADMIN_SUMMARY_ACCESS) ? { borderTop: "1px solid #1a2226", marginTop: 15, paddingTop: 5 } : {}}>
                <NavLink to="/admin/report/posted" activeClassName="active">
                  <i className="fas fa-file-alt"></i> {!collapsed && "Posted Report"}
                </NavLink>
              </li>
            )}
            {has(PERMISSION.REPORT_ATTEMPTED_ACCESS) && (
              <li>
                <NavLink to="/admin/report/attempted" activeClassName="active">
                  <i className="fas fa-phone-volume"></i> {!collapsed && "Attempted Report"}
                </NavLink>
              </li>
            )}
            {has(PERMISSION.REPORT_SOURCE_POSTING_ACCESS) && (
              <li>
                <NavLink to="/admin/report/source-wise-posting" activeClassName="active">
                  <i className="fas fa-stream"></i> {!collapsed && "Source wise posting"}
                </NavLink>
              </li>
            )}
            {has(PERMISSION.REPORT_SOURCE_DETAILED_ACCESS) && (
              <li>
                <NavLink to="/admin/report/source-wise-detailed" activeClassName="active">
                  <i className="fas fa-th-list"></i> {!collapsed && "Source wise detailed"}
                </NavLink>
              </li>
            )}
            {has(PERMISSION.TARGETS_ACCESS) && (
              <li>
                <NavLink to="/admin/targets" activeClassName="active">
                  <i className="fas fa-bullseye"></i> {!collapsed && "Daily Targets"}
                </NavLink>
              </li>
            )}
          </>
        )}
        {(has(PERMISSION.SETTINGS_CAMPAIGNS_ACCESS) || has(PERMISSION.SETTINGS_LOCATIONS_ACCESS) || has(PERMISSION.MARKETING_SPEND_ACCESS) || has(PERMISSION.MARKETING_REPORT_ACCESS)) && (
          <>
            <li style={{ borderTop: "1px solid #1a2226", marginTop: 15, paddingTop: 5, paddingLeft: 10, color: "#8aa4af", fontSize: "12px", textTransform: "uppercase" }}>
              {!collapsed && <strong>Settings</strong>}
            </li>
            {has(PERMISSION.SETTINGS_CAMPAIGNS_ACCESS) && (
              <li>
                <NavLink to="/admin/settings/campaigns" activeClassName="active">
                  <i className="fas fa-bullhorn"></i> {!collapsed && "Campaigns"}
                </NavLink>
              </li>
            )}
            {has(PERMISSION.SETTINGS_LOCATIONS_ACCESS) && (
              <li>
                <NavLink to="/admin/settings/locations" activeClassName="active">
                  <i className="fas fa-globe-asia"></i> {!collapsed && "Locations"}
                </NavLink>
              </li>
            )}
            <li style={{ borderTop: "1px solid #1a2226", marginTop: 15, paddingTop: 5, paddingLeft: 10, color: "#8aa4af", fontSize: "12px", textTransform: "uppercase" }}>
              {!collapsed && <strong>Marketing & Budget</strong>}
            </li>
            {has(PERMISSION.MARKETING_SPEND_ACCESS) && (
              <li>
                <NavLink to="/admin/marketing/spend" activeClassName="active">
                  <i className="fas fa-money-bill-wave"></i> {!collapsed && "Manage Spend/Budget"}
                </NavLink>
              </li>
            )}
            {has(PERMISSION.MARKETING_REPORT_ACCESS) && (
              <>
                <li style={{ marginTop: 10, paddingLeft: 10, color: "#8aa4af", fontSize: "11px", textTransform: "uppercase" }}>
                  {!collapsed && <strong>Marketing Reports</strong>}
                </li>
                <li>
                  <NavLink to="/admin/marketing/report" activeClassName="active">
                    <i className="fas fa-chart-bar"></i> {!collapsed && "Ad Campaign Performance Report"}
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/admin/marketing/monthly-report" activeClassName="active">
                    <i className="fas fa-calendar-alt"></i> {!collapsed && "Monthly Budget/Spent Report"}
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/admin/marketing/budget-summary" activeClassName="active">
                    <i className="fas fa-layer-group"></i> {!collapsed && "Budget Summary"}
                  </NavLink>
                </li>
              </>
            )}
          </>
        )}
        <li style={{ borderTop: "1px solid #1a2226", marginTop: 20 }}>
          <a href="#logout" onClick={handleLogout}>
            <i className="fas fa-sign-out-alt"></i> {!collapsed && "Logout"}
          </a>
        </li>
      </ul>
      {name && !collapsed && (
        <div style={{ padding: "20px", fontSize: 12, color: "#8aa4af", borderTop: "1px solid #1a2226" }}>
          <i className="fas fa-user"></i> {name}
          <br />
          <small style={{ marginLeft: 15 }}>
            ({ROLE_LABELS[role] || ROLE_LABELS[ROLE.EXECUTIVE]})
          </small>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({ name: state.name, role: state.role, permissions: state.permissions });

export default withRouter(connect(mapStateToProps, { removeAuth })(Sidebar));
